module.exports = __webpack_public_path__ + "img/visa.cb3c3720.jpg";